const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;

class EventCountdown extends HTMLElement {
  #interval;

  connectedCallback() {
    this.#render();
    document.addEventListener('visibilitychange', this.#handleVisibilityChange);
  }

  disconnectedCallback() {
    this.#stop();
    document.removeEventListener('visibilitychange', this.#handleVisibilityChange);
  }

  #handleVisibilityChange = () => {
    if (!document.hidden) this.#render();
  };

  #render() {
    this.#stop();

    const deadlineValue = this.dataset.deadline?.trim() ?? '';
    let deadline = Date.parse(deadlineValue);

    if (!deadlineValue) {
      const endOfDay = new Date(Date.now());
      endOfDay.setHours(24, 0, 0, 0);
      deadline = endOfDay.getTime() - 1;
    }

    if (Number.isNaN(deadline)) {
      this.#setTime(0, 0, 0);
      this.dataset.invalid = 'true';
      const status = this.querySelector('[data-countdown-status]');
      if (status) status.textContent = this.dataset.invalidMessage ?? '';
      return;
    }

    delete this.dataset.invalid;
    const status = this.querySelector('[data-countdown-status]');
    if (status) status.textContent = '';

    const update = () => {
      const remaining = Math.max(0, deadline - Date.now());
      const hours = Math.floor(remaining / HOUR);
      const minutes = Math.floor((remaining % HOUR) / MINUTE);
      const seconds = Math.floor((remaining % MINUTE) / SECOND);

      this.#setTime(hours, minutes, seconds);

      if (remaining === 0) {
        this.dataset.finished = 'true';
        if (status) status.textContent = this.dataset.finishedMessage ?? '';
        this.#stop();
      } else {
        delete this.dataset.finished;
      }
    };

    update();
    this.#interval = window.setInterval(update, SECOND);
  }

  #setTime(hours, minutes, seconds) {
    const values = { hours, minutes, seconds };
    this.dataset.hourDigits = String(hours).length;

    Object.entries(values).forEach(([unit, value]) => {
      const element = this.querySelector(`[data-countdown-${unit}]`);
      if (element) element.textContent = String(value).padStart(2, '0');
    });

    this.dataset.ready = 'true';
    this.setAttribute('aria-busy', 'false');
  }

  #stop() {
    if (this.#interval) window.clearInterval(this.#interval);
    this.#interval = undefined;
  }
}

if (!customElements.get('event-countdown')) {
  customElements.define('event-countdown', EventCountdown);
}
